/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    RestaurantSearchResult,
    RestaurantSearchResultFromJSON,
    RestaurantSearchResultFromJSONTyped,
    RestaurantSearchResultToJSON,
    SearchRestaurantsResponseAllOf,
    SearchRestaurantsResponseAllOfFromJSON,
    SearchRestaurantsResponseAllOfFromJSONTyped,
    SearchRestaurantsResponseAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRestaurantsResponse
 */
export interface SearchRestaurantsResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<RestaurantSearchResult>}
     * @memberof SearchRestaurantsResponse
     */
    restaurants: Array<RestaurantSearchResult>;
}

export function SearchRestaurantsResponseFromJSON(json: any): SearchRestaurantsResponse {
    return SearchRestaurantsResponseFromJSONTyped(json, false);
}

export function SearchRestaurantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRestaurantsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'restaurants': ((json['restaurants'] as Array<any>).map(RestaurantSearchResultFromJSON)),
    };
}

export function SearchRestaurantsResponseToJSON(value?: SearchRestaurantsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'restaurants': ((value.restaurants as Array<any>).map(RestaurantSearchResultToJSON)),
    };
}


